import DSTextBox from '../TextBox/DSTextBox.js';
import DSLabel from './Label/DSLabel.js';
import Feedback from './Feedback.js';
import { FORMITEM_LAYOUT_VARIANTS } from './variants.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import 'react-desc';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@babel/runtime/helpers/esm/typeof';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import 'prop-types';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-button';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import '@elliemae/ds-truncated-tooltip-text';
import '../RequiredMark/RequiredMark.js';

var defaultProps = {
  leftLabel: false,
  floatingLabel: false,
  inputComponent: DSTextBox,
  labelComponent: DSLabel,
  feedbackComponent: Feedback,
  hasError: false,
  validationMessage: '',
  feedbackMessage: '',
  focused: false,
  autoFocus: false,
  disabled: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onPaste: function onPaste() {},
  onKeyUp: function onKeyUp() {},
  extraInputProps: {},
  leftAddon: null,
  rightAddon: null,
  required: false,
  optional: false,
  useSubfix: '',
  suffix: '',
  variant: FORMITEM_LAYOUT_VARIANTS.DEFAULT,
  containerProps: {}
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
